<!--
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2022-05-18 18:12:18
 * @LastEditors: lsr lsr@qq.com
 * @Description: 注册易伙伴
 * @FilePath: \h5-vip\src\pages\registered\index.vue
-->
<template>
	<div class="app-container" :style="{ minHeight: height }">
		<img class="logoImg" src="@/assets/logobai.png" alt="" />
		<div class="box">
			<van-form @submit="onSubmit" @failed="onFailed" label-width="60px" label-align="right">
				<div class="title">
					<!-- <b style="fontSize: 18px; color: #eb7c45">{{ Invitee }}</b>
					邀请您加入易伙伴 -->
				</div>
				<van-field v-model="form.upReferKey" name="upReferKey" label="邀 请 码" placeholder="请填邀请码" :rules="rules.upReferKey" />
				<van-field v-model.trim="form.phoneNumber" label="手 机 号" name="phoneNumber" :rules="rules.phoneNumber">
					<template #input>
						<div class="phone-input-wrap">
							<div class="area-code-select" @click="showAreaCodePicker = true">
								<span>
									{{ form.phoneAreaCode }}
									({{ form.phoneAreaName }})
								</span>
								<van-icon name="arrow-down" />
							</div>
							<input v-model.trim="form.phoneNumber" maxlength="15" class="van-field__control phone-input" type="tel" placeholder="请输入手机号" />
						</div>
					</template>
				</van-field>
				<van-field v-model="form.verificationCode" name="verificationCode" maxlength="6" label="验 证 码" placeholder="请输入验证码" :rules="rules.verificationCode">
					<template #button>
						<van-button class="code" size="small" :disabled="flag" color="#f2473d" round v-if="flag">{{ time }}秒后获取</van-button>
						<van-button v-else native-type="button" size="small" color="#f2473d" round @click="goCode">获取验证码</van-button>
					</template>
				</van-field>
				<van-field
					v-model="form.password"
					name="password"
					label=" 密  码 "
					:right-icon="eye1"
					@click-right-icon="closed1"
					:type="pass1"
					placeholder="请输入密码"
					:rules="rules.password"
				/>
				<van-field
					v-model="form.confirmPassword"
					:right-icon="eye2"
					@click-right-icon="closed2"
					:type="pass2"
					name="confirmPassword"
					label="确认密码"
					placeholder="请输入确认密码"
					:rules="rules.confirmPassword"
				/>
				<div style="margin: 16px">
					<van-button round block color="#f2473d" native-type="submit" :disabled="isDisabled">立 即 加 入</van-button>
			<!-- 		<div class="download" @click="download">下载APP</div> -->
				</div>
			</van-form>
		</div>
		<van-popup v-model="showAreaCodePicker" position="bottom">
			<van-picker
				show-toolbar
				value-key="text"
				:columns="areaCodeColumns"
				@confirm="onAreaCodeConfirm"
				@cancel="showAreaCodePicker = false"
			/>
		</van-popup>

		<div class="content" ref="content"></div>
		<div class="agreement">
			<van-checkbox v-model="checkbox" checked-color="#de7423" shape="round"><span class="van-checkbox">阅读并同意</span></van-checkbox>
			<span class="check" @click="goAgreement">《易伙伴隐私政策》</span>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import { register, getCode, downloadApp, getAreaCodeList, sendSmsTreasureCode } from '@/api/index';
import { PHONE_AREA_CODES } from './phoneAreaCodes';
export default {
	name: '',
	data() {
		return {
			form: {
				phoneNumber: '',
				phoneAreaCode: PHONE_AREA_CODES[0].dial,
				phoneAreaName: PHONE_AREA_CODES[0].name,
				upReferKey: '',
				verificationCode: '',
				password: '',
				confirmPassword: ''
			},
			Invitee: '',
			checkbox: '',
			showAreaCodePicker: false,
			areaCodeColumns: PHONE_AREA_CODES.map(item => ({
				text: `${item.dial} ${item.name}`,
				code: item.dial,
				name: item.name
			})),
			rules: {
				phoneNumber: [
					{ required: true, message: '' }
				],
				password: [{ required: true, message: '' }],
				confirmPassword: [{ required: true, message: '' }],
				verificationCode: [{ required: true, message: '' }],
				upReferKey: [{ required: true, message: '' }]
			},
			flag: false,
			time: null,
			smsTimerId: null,
			browser: false,
			pass1: 'password',
			pass2: 'password',
			eye1: 'closed-eye',
			eye2: 'closed-eye',

			// 注册按钮防抖
			isDisabled: false,

			height: ''
		};
	},
	//在生命周期中获取，在方法中写法相同
	created() {
		this.$nextTick(() => {
			this.height = document.documentElement.clientHeight + 'px';
			// console.log("heigth", this.height);
			console.log(this.$refs.content.offsetHeight);
		});
		this.Invitee = this.$route.query.realName;
		this.form.upReferKey = this.$route.query.code;
		this.getisweixing();
		// 页面加载后优先使用接口区号列表，失败时保留本地兜底数据
		this.getAreaCodeListData();
		// if (this.browser) {
		//   Toast({
		//       message: "请点击右上角选择在浏览器中打开",
		//       duration: 3000,
		//     });
		// }
	
	},
	methods: {
		// 统一区号格式：接口可能返回 852，这里统一转换为 +852
		normalizeAreaCode(code) {
			if (!code && code !== 0) return '';
			const areaCode = String(code).trim();
			if (!areaCode) return '';
			return areaCode.startsWith('+') ? areaCode : `+${areaCode}`;
		},
		// 查询区号
		async getAreaCodeListData() {
			try {
				const res = await getAreaCodeList();
				// 兼容不同响应结构，避免接口层封装变更导致页面报错
				const list = Array.isArray(res.data) ? res.data : [];
				const columns = list
					.map(item => {
						// 兼容接口字段：dialCode/dial、countryName/name
						const code = this.normalizeAreaCode(item.dialCode || item.dial);
						const name = item.countryName || item.name;
						if (!code || !name) return null;
						return {
							text: `${code} ${name}`,
							code,
							name
						};
					})
					.filter(Boolean);
				// 接口无有效数据时继续使用本地区号，不清空已有列表
				if (!columns.length) return;
				this.areaCodeColumns = columns;
				const currentAreaCode = this.normalizeAreaCode(this.form.phoneAreaCode);
				const matchedArea = columns.find(item => item.code === currentAreaCode);
				if (matchedArea) {
					this.form.phoneAreaCode = matchedArea.code;
					this.form.phoneAreaName = matchedArea.name;
					return;
				}
				// 当前值在新列表不存在时，默认选中第一项避免展示空值
				this.form.phoneAreaCode = columns[0].code;
				this.form.phoneAreaName = columns[0].name;
			} catch (error) {
				console.log('getAreaCodeList error', error);
			}
		},
		// 选择区号后同步更新展示名称
		onAreaCodeConfirm(item) {
			this.form.phoneAreaCode = this.normalizeAreaCode(item.code);
			this.form.phoneAreaName = item.name;
			this.showAreaCodePicker = false;
		},
		// 表单校验失败回调（用于排查 submit 未触发）
		onFailed(errorInfo) {
			console.log('form validate failed:', errorInfo);
		},
		validatePhoneNumber() {
			const phone = this.form.phoneNumber.trim();
			if (this.form.phoneAreaCode === '+86') {
				return /^1[3-9][0-9]{9}$/.test(phone);
			}
			return /^[0-9]{6,15}$/.test(phone);
		},
		closed1() {
			// console.log(11);
			if (this.pass1 == 'password') {
				this.pass1 = 'text';
				this.eye1 = 'eye-o';
			} else {
				this.pass1 = 'password';
				this.eye1 = 'closed-eye';
			}
		},
		closed2() {
			if (this.pass2 == 'password') {
				this.pass2 = 'text';
				this.eye2 = 'eye-o';
			} else {
				this.pass2 = 'password';
				this.eye2 = 'closed-eye';
			}
		},
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger') {
				// console.log('是微信浏览器默认走微信')
				this.browser = true;
				return true; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return false;
			}
		},

		// 获取验证码
		async goCode() {
			// if (this.browser) {
			//   Toast({
			//     message: "请点击右上角选择在浏览器中打开",
			//     duration: 3000,
			//   });
			//   return;
			// }
			if (!this.validatePhoneNumber()) {
				Toast('请填写正确的手机号');
				return;
			}

			let obj = {
				// 接口要求区号为纯数字，不带 "+"
				internationalCode: this.form.phoneAreaCode.replace('+', ''),
				mobile: this.form.phoneNumber.trim(),
				isCheckPhone: false
			};

			// 倒计时进行中时不重复发送
			if (this.flag) return;

			const res = await sendSmsTreasureCode(obj);
			if (res.code != 200) {
				Toast(res.msg);
				return;
			}

			Toast('验证码已发送');

			// 接口成功后再开始倒计时
			if (this.smsTimerId) clearInterval(this.smsTimerId);
			this.time = 60;
			this.flag = true;
			this.smsTimerId = setInterval(() => {
				this.time--;
				if (this.time <= 1) {
					clearInterval(this.smsTimerId);
					this.smsTimerId = null;
					this.flag = false;
				}
			}, 1000);
		},

		// 注册事件
		async onSubmit(values) {
			if (!this.validatePhoneNumber()) {
				Toast('请填写正确的手机号');
				return;
			}
			if (this.form.password.trim().length < 6) {
				Toast('密码长度不能小于6位');
				return;
			}
			if (!this.checkbox) {
				Toast('请阅读并同意协议');
				return;
			}

			if (this.form.confirmPassword != this.form.password) {
				Toast('两次密码不一致！');
				return;
			}
			let data = {
				...this.form,
				phoneNumber: this.form.phoneNumber.trim(),
				phoneAreaCode: this.form.phoneAreaCode,
				fullPhoneNumber: `${this.form.phoneAreaCode}${this.form.phoneNumber.trim()}`,
				// 注册接口要求 icon 为纯区号数字，不带 "+"
				icon: this.form.phoneAreaCode.replace('+', ''),
			};
			console.log("注册接口参数：", data);
			
			this.isDisabled = true;
			await register(data)
				.then(res => {
					if (res.code != 200) {
						Toast({
							message: res.msg
						});
						this.isDisabled = false;
						return;
					}
					this.$toast({
						message: '注册成功，欢迎加入易伙伴~',
						duration: '3000'
					});
					var that = this;
					setTimeout(function() {
						that.$nextTick(() => {
							that.$router.push('/download');
						});
					}, 1500);
					this.isDisabled = false;
				})
				.catch(err => {
					console.log('erre', err);
				});
		},

		//  协议
		goAgreement() {
			if (this.browser) {
				Toast({
					message: '请点击右上角选择在浏览器中打开',
					duration: 3000
				});
				return;
			}
			this.$router.push('/agreement');
		},

		// 下载app
		async download() {
			if (this.browser) {
				Toast({
					message: '请点击右上角选择在浏览器中打开',
					duration: 3000
				});
				return;
			}
			await downloadApp().then(res => {
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				if (isAndroid) {
					window.location.href = res.msg;
				} else {
					window.location.href = `itms-apps://itunes.apple.com/app/id1587458887`;
				}
			});
		}
	}
};
</script>

<style scoped>
.app-container {
	position: relative;
	width: 100vw;
	display: flex;
	background-color: #da222c;
	flex-direction: column;
	justify-content: space-between;
}

.logoImg {
	width: 173.4px;
	height: 51.5px;
	margin: 8% auto 10px auto;
}

.box {
	width: 85%;
	background-color: #fff;
	border-radius: 25px;
	box-shadow: 0px 0px 40px rgba(153, 66, 22, 1);

	margin: 10px auto;
}
.box .van-cell {
	align-items: center;
}
.phone-input-wrap {
	display: flex;
	align-items: center;
	width: 100%;
}
.area-code-select {
	display: inline-flex;
	align-items: center;
	flex: 0 0 auto;
	max-width: 46%;
	min-width: 82px;
	padding-right: 8px;
	margin-right: 8px;
	border-right: 1px solid #e5e5e5;
	color: #333;
	font-size: 15px;
}
.area-code-select span {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.area-code-select .van-icon {
	flex-shrink: 0;
	margin-left: 4px;
	font-size: 14px;
}
.phone-input {
	flex: 1;
	min-width: 0;
}
.title {
	text-align: center;
	padding: 10px 0;
	font-weight: 600;
	letter-spacing: 1px;
}

.slot {
	background-color: #000000;
}

.content {
	width: 100%;
	height: 95%;
}

.agreement {
	display: flex;
	justify-content: center; /* 水平居中 */
	align-items: center;
	width: 100vw;
	margin-top: 12px;
	margin-bottom: 20px;
	text-align: center;
	z-index: 0;
	background-color: #da222c !important;
	color: #ffffff;
	/* line-height: 35.8px; */
	font-size: 16px;
	line-height: 0;
}
.agreement /deep/.van-checkbox__icon {
	font-size: 16px;
}
.van-checkbox {
	color: #ffffff;
}

.checkbox {
	vertical-align: middle;
	margin-top: 0;
	padding-right: 10px;
}

/* 下载 */
.download {
	width: 100%;
	height: 40px;
	line-height: 40px;
	text-align: center;
	margin: auto;
	margin-top: 15px;
	background-color: #eb7c45;
	border-radius: 20px;
	color: #ffffff;
}
</style>
